import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BoardEvaluationExecutionService } from '../../../services/boardEvaluationExecution.service';
import {
  ActivatedRoute,
  RouterState,
  Router,
  NavigationEnd,
} from '@angular/router';
import { Subscription, Observable } from 'rxjs';

import * as _ from 'lodash';
import * as moment from 'moment';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-evaluation-form-execution',
  templateUrl: './evaluation-form-execution.component.html',
  styleUrls: ['./evaluation-form-execution.component.css'],
})
export class EvaluationFormExecutionComponent implements OnInit, AfterViewInit {
  formId: any;
  criteriaList: any = [];
  evaluationFormDetails: any = [];
  question: any;
  criteriaName: any = {};
  scoreRange: any;
  scoreParticularDetails: any = [];
  defaultSelectedCriteria: any = [];
  defaultSelectedQuestionArray: any = [];
  questionArray: any = [];
  public activeCriteria: any;
  assignedFormId: any;
  answerDetails: any = [];
  formAnonymous: any;
  isFormEvaluated: boolean = false;
  isNextButtonEnabled: boolean = false;
  assessorId: any;
  comments: any;
  userToExecuteArray: any = [];
  assesseeListToExecute: any = [];
  subscribe: Subscription;

  constructor(
    public boardExecutionService: BoardEvaluationExecutionService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // this.formId = "5c18d14fbef8d506b89c7c0a";

    // console.log("this.userToExecuteArray",this.userToExecuteArray)
    // this.assignedFormId = "5e662a3af9293b629844200f";
    this.initialiseSubjectSubscription();

    // this.route.params.subscribe(params => {
    //   //console.log("params", params);
    //   // this.assignedFormId = params.assignedFormId;
    //   this.assignedFormId = "5e662a3af9293b629844200f";

    //   //console.log("assessmentid", this.assignedFormId);
    // });

    this.getOverallFormExecutionList();
    // this.getEvaluationFormDetails(this.assignedFormId)

    // this.getEvaluationFormDetails("5e662a3af9293b629844200f")
  }

  async initialiseSubjectSubscription() {
    this.subscribe =
      await this.boardExecutionService.usersExecutionObservable.subscribe(
        (res) => {
          this.userToExecuteArray = res;
        }
      );
  }

  ngAfterViewInit() {}

  getEvaluationFormDetails(formId) {
    var userInfo = JSON.parse(localStorage.getItem('user'));

    var self = this;
    //console.log("formId", formId);
    // this.boardExecutionService.getEvaluationFormDetails(formId).then(response => {
    this.boardExecutionService
      .getAssignedEvalutionFormDetails(formId)
      .then((response) => {
        //console.log("response", response.assignedFormDetails);
        this.answerDetails = response.assignedFormDetails[0].Answers;
        //console.log("this.answerDetails", this.answerDetails);
        this.isFormEvaluated = response.assignedFormDetails[0].IsFormEvaluated;
        //console.log("this.isFormEvaluated ", this.isFormEvaluated);
        this.assessorId = response.assignedFormDetails[0].AssessorId;
        this.comments = response.assignedFormDetails[0].Comments;

        if (this.assessorId == userInfo._id) {
          this.isNextButtonEnabled = true;
        } else {
          this.isNextButtonEnabled = false;
        }
        //console.log("this.assessorId ", this.assessorId);
        this.boardExecutionService
          .getEvaluationFormDetails(
            response.assignedFormDetails[0].EvaluationFormId._id
          )
          .then((formResponse) => {
            this.evaluationFormDetails = formResponse.EvaluationDetails;
            //console.log("this.evaluationFormDetails", this.evaluationFormDetails);
            this.scoreRange = this.evaluationFormDetails.ScoreRange;
            // _.forEach(self.evaluationFormDetails.ScoreParticulars, function (data) {
            //   self.scoreParticularDetails.push({ 'scoreValue': data.Value });
            // })
            for (
              var i = 0;
              i < this.evaluationFormDetails.ScoreParticulars.length;
              i++
            ) {
              this.scoreParticularDetails.push({
                scoreValue:
                  this.evaluationFormDetails.ScoreParticulars[i].Value,
                index: i,
              });
            }
            // //console.log("scoreParticularDetails=================", this.scoreParticularDetails)
            this.formAnonymous = this.evaluationFormDetails.IsAnonymous;
            //console.log("_.size(this.evaluationFormDetails.EvaluationCriterias)", this.evaluationFormDetails.EvaluationCriterias)
            if (_.size(this.evaluationFormDetails.EvaluationCriterias)) {
              _.forEach(
                self.evaluationFormDetails.EvaluationCriterias,
                function (criteria) {
                  let criteriaWithQuestionList = criteria.EvaluationCriteriaID;

                  criteriaWithQuestionList['EvaluationQuestion'] =
                    criteria.EvaluationQuestion;
                  self.criteriaList.push(criteriaWithQuestionList);
                  // self.criteriaList.push(criteria)
                }
              );

              //console.log("self.criteriaList", self.criteriaList)
              self.criteriaName = {
                _id: self.criteriaList[0]._id,
                EvaluationCriteria: self.criteriaList[0].EvaluationCriteria,
              };
              self.defaultSelectedCriteria =
                self.criteriaList[0].EvaluationQuestion[0].EvaluationQuestionId;

              self.selectQuestion(self.defaultSelectedCriteria, function () {
                self.activeQuestion(self.defaultSelectedCriteria);
              });
            }
          });
        //....
      });
  }

  selectQuestion(questionObject, callback) {
    //console.log("questionObject", questionObject);
    this.question = questionObject;
    callback();
  }

  selectQuestionForSideBar(event) {
    var self = this;
    _.forEach(this.criteriaList, function (criteria) {
      if (_.size(criteria.EvaluationQuestion)) {
        criteria.EvaluationQuestion.forEach((question) => {
          if (question.EvaluationQuestionId._id == event) {
            // //console.log("selectd question", question.EvaluationQuestionId)
            self.question = question.EvaluationQuestionId;
            self.criteriaName = {
              _id: criteria._id,
              EvaluationCriteria: criteria.EvaluationCriteria,
            };
          }
        });
      }
    });
    //console.log("event", event);
  }

  questionChangedStatus(questionObject) {
    const self = this;
    // //console.log("questionObject - -", questionObject)
    // this.criteriaList.forEach(element => {
    //     element.Question.forEach(data => {
    //         if (data._id === questionObject.response._id) {
    //             data.QuestionStatus = questionObject.response.QuestionStatus;
    //         }
    //     });
    // });
    switch (questionObject.buttonClick) {
      case 'next':
        this.nextAndSkipQuestion(questionObject);
        break;
      case 'skip':
        this.skipQuestion(questionObject);
        break;
      case 'previous':
        this.previousQuestion(questionObject);
        break;
      case 'mark':
        this.skipQuestion(questionObject);
        break;
      default:
    }
    // changed the status of the question for side bar
    // call the next question by API.
  }

  nextAndSkipQuestion(questionObject) {
    //console.log("next and save", questionObject);

    const self = this;
    let nextQuestionId: any;

    if (questionObject.buttonClick === 'next') {
      const foundCategory = _.find(self.criteriaList, function (o) {
        return o._id === self.criteriaName._id;
      });
      // console.log("foundCategory",foundCategory);
      const currentQuestionIndex = _.findIndex(
        foundCategory.EvaluationQuestion,
        function (o) {
          return (
            _.get(_.get(o, 'EvaluationQuestionId'), '_id') ===
            questionObject.questionid
          );
        }
      );
      // //console.log("currentQuestionIndex",currentQuestionIndex);

      const indexOfCurrentCategory = _.findIndex(
        self.criteriaList,
        function (o) {
          return _.get(o, '_id') === self.criteriaName._id;
        }
      );
      // //console.log("indexOfCurrentCategory",indexOfCurrentCategory);

      if (
        _.toInteger(currentQuestionIndex) + 1 ===
        _.size(foundCategory.EvaluationQuestion)
      ) {
        // if question index equals size of question then next criteria

        if (
          _.toInteger(indexOfCurrentCategory) + 1 <
          _.size(self.criteriaList)
        ) {
          self.criteriaName = {
            _id: self.criteriaList[indexOfCurrentCategory + 1]._id,
            EvaluationCriteria:
              self.criteriaList[indexOfCurrentCategory + 1].EvaluationCriteria,
          };
          self.activeCriteria = self.criteriaList[indexOfCurrentCategory + 1];
          self.selectQuestion(
            self.criteriaList[indexOfCurrentCategory + 1].EvaluationQuestion[0]
              .EvaluationQuestionId,
            function () {
              self.activeQuestion(
                self.criteriaList[indexOfCurrentCategory + 1]
                  .EvaluationQuestion[0].EvaluationQuestionId
              );
            }
          );
        }
      } else {
        // next question

        if (
          _.toInteger(indexOfCurrentCategory) + 1 <=
          _.size(self.criteriaList)
        ) {
          this.criteriaName = {
            _id: self.criteriaList[indexOfCurrentCategory]._id,
            EvaluationCriteria:
              self.criteriaList[indexOfCurrentCategory].EvaluationCriteria,
          };
          nextQuestionId =
            foundCategory.EvaluationQuestion[currentQuestionIndex + 1]
              .EvaluationQuestionId;
          self.selectQuestion(nextQuestionId, function () {
            self.activeQuestion(nextQuestionId);
          });
        }
      }
    }
  }

  skipQuestion(questionObject) {
    // //console.log("skipks", questionObject)
    let nextQuestionId: any;

    const self = this;
    const foundCategory = _.find(self.criteriaList, function (o) {
      return o._id === self.criteriaName._id;
    });
    const currentQuestionIndex = _.findIndex(
      foundCategory.EvaluationQuestion,
      function (o) {
        return (
          _.get(_.get(o, 'EvaluationQuestionId'), '_id') ===
          questionObject.questionid
        );
      }
    );
    const indexOfCurrentCategory = _.findIndex(self.criteriaList, function (o) {
      return _.get(o, '_id') === self.criteriaName._id;
    });

    if (
      _.toInteger(currentQuestionIndex) + 1 ===
      _.size(foundCategory.EvaluationQuestion)
    ) {
      //next category question
      if (_.toInteger(indexOfCurrentCategory) + 1 < _.size(self.criteriaList)) {
        self.criteriaName = {
          _id: self.criteriaList[indexOfCurrentCategory + 1]._id,
          EvaluationCriteria:
            self.criteriaList[indexOfCurrentCategory + 1].EvaluationCriteria,
        };
        self.activeCriteria = self.criteriaList[indexOfCurrentCategory + 1];
        self.selectQuestion(
          self.criteriaList[indexOfCurrentCategory + 1].EvaluationQuestion[0]
            .EvaluationQuestionId,
          function () {
            self.activeQuestion(
              self.criteriaList[indexOfCurrentCategory + 1]
                .EvaluationQuestion[0].EvaluationQuestionId
            );
          }
        );
      } else {
        // //console.log("self.criteriaList[indexOfCurrentCategory + 1]",self.criteriaList[indexOfCurrentCategory + 1])
        if (!_.isUndefined(self.criteriaList[indexOfCurrentCategory + 1])) {
          self.criteriaName = {
            _id: self.criteriaList[indexOfCurrentCategory + 1]._id,
            EvaluationCriteria:
              self.criteriaList[indexOfCurrentCategory + 1].EvaluationCriteria,
          };
          self.activeCriteria = self.criteriaList[indexOfCurrentCategory + 1];
          const lastQuestId = _.get(
            _.last(
              self.criteriaList[indexOfCurrentCategory].EvaluationQuestion
            ),
            'EvaluationQuestionId'
          );
          self.selectQuestion(lastQuestId, function () {
            self.activeQuestion(nextQuestionId);
          });
        }
      }
    } else {
      // next question
      if (
        _.toInteger(indexOfCurrentCategory) + 1 <=
        _.size(self.criteriaList)
      ) {
        this.criteriaName = {
          _id: self.criteriaList[indexOfCurrentCategory]._id,
          EvaluationCriteria:
            self.criteriaList[indexOfCurrentCategory].EvaluationCriteria,
        };
        nextQuestionId =
          foundCategory.EvaluationQuestion[currentQuestionIndex + 1]
            .EvaluationQuestionId;
        self.selectQuestion(nextQuestionId, function () {
          self.activeQuestion(nextQuestionId);
        });
      }
    }
  }

  previousQuestion(questionObject) {
    // //console.log("previous", questionObject)
    const self = this;
    const foundCategory = _.find(self.criteriaList, function (o) {
      return o._id === self.criteriaName._id;
    });

    const currentQuestionIndex = _.findIndex(
      foundCategory.EvaluationQuestion,
      function (o) {
        return (
          _.get(_.get(o, 'EvaluationQuestionId'), '_id') ===
          questionObject.questionid
        );
      }
    );
    const indexOfCurrentCategory = _.findIndex(self.criteriaList, function (o) {
      return _.get(o, '_id') === self.criteriaName._id;
    });

    if (_.toInteger(currentQuestionIndex) === 0) {
      // for load previous category and first question
      if (_.toInteger(indexOfCurrentCategory) !== 0) {
        self.criteriaName = {
          _id: self.criteriaList[indexOfCurrentCategory - 1]._id,
          EvaluationCriteria:
            self.criteriaList[indexOfCurrentCategory - 1].EvaluationCriteria,
        };
        self.activeCriteria = self.criteriaList[indexOfCurrentCategory - 1];
        const lastQuestId = _.get(
          _.last(
            self.criteriaList[indexOfCurrentCategory - 1].EvaluationQuestion
          ),
          'EvaluationQuestionId'
        );
        self.selectQuestion(lastQuestId, function () {
          self.criteriaList.forEach((element) => {
            if (element._id === self.criteriaName._id) {
              element.isOpened = true;
            } else {
              element.isOpened = false;
            }
          });

          self.activeQuestion(lastQuestId);
        });
      }
    } else {
      self.criteriaName = {
        _id: self.criteriaList[indexOfCurrentCategory]._id,
        EvaluationCriteria:
          self.criteriaList[indexOfCurrentCategory].EvaluationCriteria,
      };
      const previousQuesId =
        foundCategory.EvaluationQuestion[currentQuestionIndex - 1]
          .EvaluationQuestionId;
      this.selectQuestion(previousQuesId, function () {
        self.activeQuestion(previousQuesId);
      });
    }
  }

  activeQuestion(QuestionId) {
    // //console.log("active question",QuestionId)
    this.criteriaList.forEach((criteria) => {
      if (_.size(criteria.EvaluationQuestion)) {
        criteria.EvaluationQuestion.forEach((question) => {
          if (question.EvaluationQuestionId._id == QuestionId._id) {
            question.EvaluationQuestionId.isActive = true;
          } else {
            question.EvaluationQuestionId.isActive = false;
          }
          this.checkQuestionAnswered(question);
        });
      }
    });
    // //console.log("this.criteriaList activate question", this.criteriaList)
  }

  selectedCriteria(data) {
    const self = this;
    let criteriaObject = null;
    let firstQuestionId = null;
    criteriaObject = _.find(self.criteriaList, function (o) {
      return o._id === data.panelId;
    });
    this.activeCriteria = criteriaObject;
    this.criteriaName = {
      _id: criteriaObject._id,
      EvaluationCriteria: criteriaObject.EvaluationCriteria,
    };
    firstQuestionId = _.get(
      _.first(criteriaObject.EvaluationQuestion),
      'EvaluationQuestionId'
    );
    this.selectQuestion(firstQuestionId, function () {
      self.activeQuestion(firstQuestionId);
    });
  }

  changeAnswerDetails(event) {
    // //console.log("answer Details--event", event);
    this.answerDetails = event;
    // if(_.size())
  }

  changeCriteriaList(event) {
    this.criteriaList = event;
    // //console.log("this.criteriaList",this.criteriaList);
  }

  ngOnDestroy() {
    this.boardExecutionService.commentsEvent$.next(false);
    this.subscribe.unsubscribe();
  }

  getOverallFormExecutionList() {
    var userInfo = JSON.parse(localStorage.getItem('user'));

    this.boardExecutionService
      .getAssignedEvalutionFormDetailsByArrayOfId(this.userToExecuteArray)
      .then((res) => {
        // console.log("array of ids result", res)
        var evaluationFormTypeDetails = res.assignedFormDetails;
        this.assesseeListToExecute = evaluationFormTypeDetails;

        var evaluationFormTypeId = '';
        // console.log("evaluationFormTypeDetails",evaluationFormTypeDetails)
        if (_.size(evaluationFormTypeDetails) > 0) {
          evaluationFormTypeId =
            evaluationFormTypeDetails[0].EvaluationFormId._id;
          this.assessorId = evaluationFormTypeDetails[0].AssessorId;
          if (this.assessorId == userInfo._id) {
            this.isNextButtonEnabled = true;
          } else {
            this.isNextButtonEnabled = false;
          }
          // console.log("isNextButtonEnabled", this.isNextButtonEnabled)
          this.intitialseFormQuestionAndCriteriasByFormTypeId(
            evaluationFormTypeId
          );
        }
      });
  }

  intitialseFormQuestionAndCriteriasByFormTypeId(id) {
    // console.log("id",id)
    var self = this;
    this.boardExecutionService
      .getEvaluationFormDetails(id)
      .then((formResponse) => {
        this.evaluationFormDetails = formResponse.EvaluationDetails;
        //console.log("this.evaluationFormDetails", this.evaluationFormDetails);
        this.scoreRange = this.evaluationFormDetails.ScoreRange;
        // _.forEach(self.evaluationFormDetails.ScoreParticulars, function (data) {
        //   self.scoreParticularDetails.push({ 'scoreValue': data.Value });
        // })
        for (
          var i = 0;
          i < this.evaluationFormDetails.ScoreParticulars.length;
          i++
        ) {
          this.scoreParticularDetails.push({
            scoreValue: this.evaluationFormDetails.ScoreParticulars[i].Value,
            index: i,
          });
        }
        // //console.log("scoreParticularDetails=================", this.scoreParticularDetails)
        this.formAnonymous = this.evaluationFormDetails.IsAnonymous;
        //console.log("_.size(this.evaluationFormDetails.EvaluationCriterias)", this.evaluationFormDetails.EvaluationCriterias)
        if (_.size(this.evaluationFormDetails.EvaluationCriterias)) {
          _.forEach(
            self.evaluationFormDetails.EvaluationCriterias,
            function (criteria) {
              let criteriaWithQuestionList = criteria.EvaluationCriteriaID;

              criteriaWithQuestionList['EvaluationQuestion'] =
                criteria.EvaluationQuestion;
              self.criteriaList.push(criteriaWithQuestionList);
              // self.criteriaList.push(criteria)
            }
          );
          this.markQuestionStatus();
          //console.log("self.criteriaList", self.criteriaList)
          self.criteriaName = {
            _id: self.criteriaList[0]._id,
            EvaluationCriteria: self.criteriaList[0].EvaluationCriteria,
          };
          self.defaultSelectedCriteria =
            self.criteriaList[0].EvaluationQuestion[0].EvaluationQuestionId;

          self.selectQuestion(self.defaultSelectedCriteria, function () {
            self.activeQuestion(self.defaultSelectedCriteria);
          });
          // this.markQuestionStatus();
        }
      });
  }

  submitAnswerById(event) {
    // console.log("event",event)
    if (event.response.status == 0) {
      this.nextAndSkipQuestion(event);
      this.assesseeListToExecute =
        event.response.UpdatedAssignedEvaluationFormDetails;
    }

    // this.boardExecutionService.answerOverallEvaluationFormExecution()
  }

  submitComment(event) {
    if (event.status == 0) {
      this.assesseeListToExecute = event.assignedFormDetails;
    }
    // this.assesseeListToExecute = event
    // this.getOverallFormExecutionList()
  }

  markQuestionStatus() {
    this.criteriaList.forEach((criteria) => {
      if (_.size(criteria.EvaluationQuestion)) {
        criteria.EvaluationQuestion.forEach((question) => {
          this.checkQuestionAnswered(question);
        });
      }
    });
  }

  checkQuestionAnswered(question) {
    // console.log("question",question)
    var totalSize = _.size(this.assesseeListToExecute);
    var count = 0;
    if (
      !_.isUndefined(this.assesseeListToExecute) &&
      _.size(this.assesseeListToExecute) > 0
    ) {
      this.assesseeListToExecute.forEach((element) => {
        if (_.size(element.Answers) > 0) {
          var found = element.Answers.findIndex((answerElement) => {
            return (
              answerElement.QuestionId == question.EvaluationQuestionId._id &&
              answerElement.AnswerStatus == 'Answered'
            );
          });
          // console.log("found",found)
          if (found >= 0) {
            count = count + 1;
          }
        }
      });

      if (!_.isUndefined(question)) {
        // console.log("count", count , totalSize)
        if (count == totalSize) {
          question.EvaluationQuestionId.answerStatus = 'Answered';
        } else {
          question.EvaluationQuestionId.answerStatus = 'Not Answered';
        }
      }
    }
    // console.log("question- updated",question,  question.EvaluationQuestionId.answerStatus)
  }
}
